export enum UnitOfMeasure {
  Meters = 'METERS',
  Kilometers = 'KILOMETERS',
  Miles = 'MILES',
  Feet = 'FEET',
}

export const toMeters = (unit: UnitOfMeasure, value: number) => {
  switch (unit) {
    case UnitOfMeasure.Meters:
      return value;
    case UnitOfMeasure.Feet:
      return value * 0.3048;
    case UnitOfMeasure.Kilometers:
      return value * 1000;
    case UnitOfMeasure.Miles:
      return value * 1609.34;
    default:
      throw new Error(`Unsupported unit "${unit}"`);
  }
};
